const GENERIC_TYPES = new Set([
  "restaurant",
  "food",
  "point_of_interest",
  "establishment",
  "store",
  "meal_takeaway",
  "meal_delivery",
]);

export function getCuisineLabels(types: unknown): string[] {
  if (!Array.isArray(types)) return [];
  return types
    .filter((t): t is string => typeof t === "string" && !GENERIC_TYPES.has(t))
    .map((t) =>
      t
        .replace(/_restaurant$/, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase())
    );
}

export function getPrimaryCuisine(types: unknown): string | null {
  return getCuisineLabels(types)[0] ?? null;
}
